var url = "https://be31-111-17-98-74.jp.ngrok.io/";
url = "https://bonus.yuweiyeke.com"
let appid = 'wxf813bc46612bca73'
export default{
  url: url,
  wxAppId: appid,
  debug: true
}
